import { ReactNode } from "react";
import styles from "../CategorizedNomenclatureListPage.module.scss";
import { DefaultButton } from "../../components/button/defaultButton/DefaultButton";
import { RenderWhen, IfTrue, IfFalse } from "../../infrastructure/components/RenderWhen";

interface IPageTitleSectionProps {
  title: string;
  description?: string;
  isLoading: boolean;
  showReorderButton: boolean;
  onReorderClick: () => void;
  /** Filter trigger shown opposite the page title. */
  filterButton?: ReactNode;
  /** Number of active records, rendered in brackets after the title. */
  itemsCount?: number;
}

export const PageTitleSection = ({
  title,
  description,
  isLoading,
  showReorderButton,
  onReorderClick,
  filterButton,
  itemsCount,
}: IPageTitleSectionProps) => {
  return (
    <div className={styles.title_tile}>
      <div className={styles.title_tile_info}>
        <h2 className={styles.title_tile_text}>
          {title}
          <RenderWhen condition={itemsCount !== undefined}>
            <span className={styles.title_tile_count}> ({itemsCount})</span>
          </RenderWhen>
        </h2>
        {description && (
          <p className={styles.title_tile_description}>{description}</p>
        )}
      </div>
      {/* Sibling of the actions block, so on mobile it stays on the title row
          while a full-width action button wraps onto its own row below. */}
      <RenderWhen condition={!!filterButton}>
        <div className={styles.title_tile_filter}>{filterButton}</div>
      </RenderWhen>

      {(isLoading || showReorderButton) && (
        <div className={styles.title_tile_actions}>
          <RenderWhen condition={isLoading}>
            <IfTrue>
              <div className={styles.skeleton_button} />
            </IfTrue>
            <IfFalse>
              <RenderWhen condition={showReorderButton}>
                <DefaultButton
                  label="Подреди категории"
                  design="outline"
                  onClick={onReorderClick}
                  width="auto"
                  className={styles.reorder_categories_button}
                />
              </RenderWhen>
            </IfFalse>
          </RenderWhen>
        </div>
      )}
    </div>
  );
};
